import { useCallback } from 'react';
import { JOBS_TABLE_COLUMNS, JOBS_TABLE_COLUMN_DATA } from 'modules/jobManager/types';
import { DoubleArrow } from 'ui/icons/navigation/DoubleArrow';
import { DownArrow } from 'ui/icons/navigation/DownArrow';
import { UpArrow } from 'ui/icons/navigation/UpArrow';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { StyledHeaderButton } from './Styled';

type HeaderRowCellProps = {
  column: JOBS_TABLE_COLUMN_DATA;
  isActiveSortColumn: boolean;
  sortDirection: SORT_DIRECTIONS;
  setSortedBy: (sortedBy: JOBS_TABLE_COLUMNS) => void;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
};

export const HeaderRowCell = ({
  column,
  isActiveSortColumn,
  sortDirection,
  setSortDirection,
  setSortedBy,
}: HeaderRowCellProps) => {
  const isAscendingSort = sortDirection === SORT_DIRECTIONS.ASCENDING;
  const handleClick = useCallback(() => {
    if (isActiveSortColumn) {
      setSortDirection(isAscendingSort ? SORT_DIRECTIONS.DESCENDING : SORT_DIRECTIONS.ASCENDING);
    } else if (column.isSortable) {
      setSortedBy(column.id);
      setSortDirection(column.initialSortDirection || SORT_DIRECTIONS.DESCENDING);
    }
  }, [
    setSortDirection,
    setSortedBy,
    column.isSortable,
    column.id,
    isAscendingSort,
    isActiveSortColumn,
    column.initialSortDirection,
  ]);
  const isSortableAndActive = column.isSortable && isActiveSortColumn;

  return (
    <StyledHeaderButton
      isSortable={column.isSortable}
      isActiveSortColumn={isActiveSortColumn}
      isRightAligned={column.isRightAligned}
      as={column.isSortable ? 'button' : 'div'}
      data-test={`column-header-${column.id}`}
      key={column.id}
      onClick={handleClick}
    >
      <span>{column.label}</span>

      {column.isSortable && !isActiveSortColumn && <DoubleArrow isColorInherited />}
      {isSortableAndActive && isAscendingSort && <UpArrow isColorInherited />}
      {isSortableAndActive && !isAscendingSort && <DownArrow isColorInherited />}
    </StyledHeaderButton>
  );
};
